import { type ComponentsOverrides } from '@mui/material/styles'

export const overridesSkeleton = (): ComponentsOverrides['MuiSkeleton'] => ({
  text: {
    // Pour être ISO Mui v4
    transformOrigin: '0 60%',
  },
})
